import { render, staticRenderFns } from "./IconWifi.vue?vue&type=template&id=09a12fc8&scoped=true"
import script from "./IconWifi.vue?vue&type=script&lang=js"
export * from "./IconWifi.vue?vue&type=script&lang=js"
import style0 from "./IconWifi.vue?vue&type=style&index=0&id=09a12fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a12fc8",
  null
  
)

export default component.exports